<template>
  <div>
    <div class="slide-proportion-2-3">
      <div class="left-block-positioner">
        <h1 class="slide-header">ФАКТ 2</h1>
        <p class="tagline">
          Білий ведмідь здатний проплисти 687 км без перерви на відпочинок, щоб
          зайти на ОККО за арктичним дизелем.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  @import '~styles/scss/slide-fragment.scss';
</style>



// WEBPACK FOOTER //
// src/components/SlideFragment/Slides/Fact2/Left.vue